module.exports = __webpack_public_path__ + "static/img/9df13f6ed0211483d92e7df83db810c7.9c63ce5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/9df13f6ed0211483d92e7df83db810c7.jpg
// module id = H+Pu
// module chunks = 4